import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {Router} from "@angular/router";
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
@Component({
    selector: 'app-clone-type',
    templateUrl: './clone-type.component.html',
    styleUrls: ['./clone-type.component.scss'],
    standalone: false
})
export class CloneTypeComponent extends SubscriptionUtil implements OnInit {
  translate: any;
  data: any;
  joTypeName: string = '';
  hasError: boolean = false;
  hasLengthError: boolean = false;

  constructor(
    public modalRef: BsModalRef, private bsModalServc: BsModalService, private router: Router,

    private languageTranslateService: LanguageTranslateService,
  ) { 
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    //default value as per coda (bug CS-7243)
    this.joTypeName = "Copy of " + this.data?.name;
  }

  confirm(){
    if (!this.joTypeName || this.joTypeName.trim().length === 0){
      this.hasError = true;
      return;
    }
    if (this.joTypeName.trim().length > 80) {
      this.hasLengthError= true;
      return;
    }
    this.hasError = false;
    this.hasLengthError = false;
    this.modalRef.hide();
    console.log(this.data, 'data before route')
    this.router.navigate(['/dashboard/setup/jobOrder/type-standalone/create'], {state: {joTypeName: this.joTypeName, clonedId: this.data.id}});
  }

  onNameChange(event: any){
    if (this.joTypeName && this.joTypeName.trim().length > 0){
      this.hasError = false;
    }
    else{
      this.hasError = true;
    }

    if (this.joTypeName && this.joTypeName.trim().length > 80) {
      this.hasLengthError = true;
    } else {
      this.hasLengthError = false;
    }
  }

  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
      }
    }))
    console.log("translate",this.translate)
  }

  push(obs:any) {
    super.push(obs);
  }

}
